// extracted by mini-css-extract-plugin
module.exports = {"block":"pagination_block__1B-ay","currentPage":"pagination_currentPage__1QflE"};